<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Bons de charge clients",
          icon: "bi bi-archive-fill",
          route: "orders-index",
        },
        {
          label: "Nouveau bon client",
          icon: "bi bi-plus-circle-fill",
          route: "orders-create",
        },
        {
          label: "Bons fournisseurs",
          icon: "bi bi-box-seam-fill",
          route: "orders-suppliers-index",
        },
        {
          label: "Nouveau bon fournisseur",
          icon: "bi bi-cart-plus-fill",
          route: "orders-suppliers-create",
        },
      ],
    };
  },
};
</script>
